module.exports = {
  GENERIC: 'GENERIC',
  GLOBAL_PRESETS: 'GLOBAL_PRESETS',
  REPORT_CATEGORIES: 'REPORT_CATEGORIES',
  REPORTS: 'REPORTS',
  CATEGORIES_TAGS: 'CATEGORIES/TAGS',
  CATEGORY: 'CATEGORY',
  TAGGROUP1: 'GROUP1',
  TAGGROUP2: 'GROUP2',
  TAGGROUP3: 'GROUP3',
  TAGGROUP4: 'GROUP4',
  OPERATOR: 'OPERATOR',
  OPERATORIMPC: 'OPERATOR/IMPC',
  LOCATION: 'LOCATION',
  DESPATCHTYPE: 'DESPATCH TYPE',
  OPERATORMAILBOX: 'OPERATOR/MAILBOX',
  MRDIMPC: 'MRD IMPC',
};
